import React, { useRef, useState } from 'react';
import TextBox, { InputType } from '../Components/CoreComponents/textbox';
import TextArea from '../Components/CoreComponents/textarea';
import LoadingButton from '../Components/CoreComponents/button';
import { FaCommentDots } from 'react-icons/fa';
import { StartChatRequest } from '../../Model/Request/ClientUser/StartChatRequest';
import { StartChat } from '../../Controller/Api/ChatClientUserController';
import { ApiBaseResponse, ResponseCode } from '../../Model/Response/Common/ApiBaseResponse';
import { StartChatResponse } from '../../Model/Response/ClientUser/StartChatResponse';
import { useLocation } from 'react-router-dom';
import { GetServiceDetailResponse } from '../../Model/Response/MusteriKurumTanim/GetServiceDetailResponse';

interface UserFormProps {
    onSubmit: (chatResponse: StartChatResponse) => void;
    serviceDetail: GetServiceDetailResponse | null;
}

const UserForm: React.FC<UserFormProps> = ({ onSubmit, serviceDetail }) => {
    const nameRef = useRef<any>(null);
    const phoneRef = useRef<any>(null);
    const messageRef = useRef<any>(null);

    const [message, setMessage] = useState('');

    const query = new URLSearchParams(useLocation().search);
    const sGuid = query.get('guid');
    const hId = query.get('hId');
    const botId = query.get('botId');
    const botToken = query.get('botToken');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const isNameValid = nameRef.current?.validate();
        const isPhoneValid = phoneRef.current?.validate();
        const isMessageValid = messageRef.current?.validate();

        if (isNameValid && isPhoneValid && isMessageValid) {
            const message = messageRef.current?.getValue();

            const request: StartChatRequest = {
                messageSenderName: nameRef.current?.getValue(),
                messageSenderTel: phoneRef.current?.getValue(),
                messageSenderMessage: message,
                serviceGuid: sGuid ?? '',
                serviceId: Number(hId) ,
                chatBotId: botId ? Number(botId) : 0, // botId varsa, yoksa 0
                chatBotToken: botToken ?? null, // botToken varsa, yoksa boş string
            };

            let response: ApiBaseResponse<StartChatResponse> | null =
                await StartChat(request);

            if (response == null || response.content == null || response.responseCode != ResponseCode.OK) {
                // Hata mesajı göster
                return;
            }
            onSubmit(response.content);
        }
    };

    const inputStyle = {
        width: '100%',
        padding: '8px',
        marginTop: '5px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    };

    return (
        <div
            style={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '20px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'white'
            }}
        >
            {serviceDetail && (
                <>
                    <TextBox
                        ref={nameRef}
                        label="İsim Soyisim"
                        inputId="name"
                        required
                        placeholder="Adınızı ve soyadınızı girin"
                        errorMessage="İsim ve Soyisim Girilmelidir"
                        type={InputType.TEXT}
                        style={inputStyle}
                    />
                    <TextBox
                        ref={phoneRef}
                        label="Telefon Numarası"
                        inputId="phone"
                        required
                        placeholder="Telefon numaranızı girin"
                        errorMessage="Telefon Numarası Girilmelidir"
                        type={InputType.TEL}
                        style={inputStyle}
                    />
                    <TextArea
                        ref={messageRef}
                        label="Mesajınız"
                        inputId="message"
                        required
                        placeholder="Mesajınızı girin ve Sohbeti Başlat düğmesine tıklayın."
                        errorMessage="Mesaj Girilmelidir"
                        rows={5}
                        style={inputStyle}
                        value={message}
                        onChange={(value: string) => setMessage(value)}
                    />
                    <br></br>
                    <LoadingButton
                        label={
                            <>
                                <FaCommentDots style={{ marginRight: '8px' }} />
                                Sohbeti Başlat
                            </>
                        }
                        onClick={handleSubmit}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#2980b9',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            alignSelf: 'flex-end',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                        }}
                    />
                </>
            )}
        </div>
    );
};

export default UserForm;
